module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/banner_hometown@3x-6d719fe5eae08fcc7480df2ef372fc5c.webp";